// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27WTK","label":"styles_label__3LpAM"};